export default __webpack_public_path__ + "static/media/Broadcasting.22713075.png";